import React from "react";
import AsyncSelect from "react-select/async";
import {
  ActionMeta,
  StylesConfig,
  SingleValue,
  components,
} from "react-select";

export interface SelectOption {
  value: string;
  label: string;
}

interface SingleSelectAsyncProps {
  value: SelectOption | null;
  onChange: (
    value: SelectOption | null,
    actionMeta: ActionMeta<SelectOption>
  ) => void;
  isSearchable?: boolean;
  type?: "year" | "entity" | "employee" | "title";
  loadOptions: (inputValue: string) => Promise<SelectOption[]>;
  defaultOptions?: boolean | SelectOption[];
}

export const SingleSelectAsync: React.FC<SingleSelectAsyncProps> = ({
  value,
  onChange,
  isSearchable = true,
  type = "entity",
  loadOptions,
  defaultOptions = true,
}) => {
  const handleChange = (
    newValue: SingleValue<SelectOption>,
    actionMeta: ActionMeta<SelectOption>
  ) => {
    onChange(newValue ?? null, actionMeta);
  };

  const customStyles: StylesConfig<SelectOption, false> = {
    control: (base) => ({
      ...base,
      minHeight: "30px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "2px 4px",
    }),
    singleValue: (base) => ({
      ...base,
      lineHeight: 1.2,
    }),
  };

  return (
    <AsyncSelect<SelectOption, false>
      placeholder="Select..."
      value={value}
      onChange={handleChange}
      isSearchable={isSearchable}
      loadOptions={loadOptions}
      defaultOptions={defaultOptions}
      styles={customStyles}
    />
  );
};